const subscriptionSelectors = {
  StepsContainer: ".subscription-picker__fieldset",
  selectionCardInputs: ".subscription-picker__card-radio",
  formSubmit: ".subscription-picker__submit-btn",
  summarySection: ".subscription-picker__summary-flex-container",
  subDetail1: ".subscription-picker__summary-line-item.summary__choice-1",
  subDetail2: ".subscription-picker__summary-line-item.summary__choice-2",
  subDetail3: ".subscription-picker__summary-line-item.summary__choice-3",
  subDetail4: ".subscription-picker__summary-line-item.summary__choice-4",
  subDetailImg: ".subscription-picker__summary-img",
  subSavings: ".subscription-picker__summary-savings-price",
  subTotal: ".subscription-picker__summary-total-price",
  cardTitle: ".subscription-picker__card-title",
  cardImg: "img",
  cardInput: "input",
  cardDescription: ".subscription-picker__card-bottom-description",
  cardDescriptionBold: ".subscription-picker__card-bottom-description span",
  notAvailableMessage: ".subscription-picker__unavailable-container",
};

class SubscriptionPicker {
  constructor(collectionsData) {
    this.collectionsData = collectionsData;
    this.selectedCollection = [];
    this.filteredCollection = [];
    this.filter1 = null;
    this.filter2 = null;
    this.filter3 = null;
    this.collectionName = null;
    this.filter1Label = null;
    this.filter2Label = null;
    this.filter3Label = null;
    this.selectedProduct = null;
    this.selectedVariant = null;
    this.stepsContainers = document.querySelectorAll(
      subscriptionSelectors.StepsContainer
    );
  }

  init() {
    this.addEventListeners();
    this.revealNextSection(this.stepsContainers[0]);
    this.enableSectionInputs(this.stepsContainers[0]);
  }

  addEventListeners() {
    this.initCollectionSelectListener();
    this.initFilterSelectListener();
    this.initFormSubmitListener();
  }

  revealNextSection(section) {
    this.opacityFull(section);
  }

  enableSectionInputs(sectionEl) {
    const inputs = sectionEl.querySelectorAll("input");
    inputs.forEach((input) => {
      input.disabled = false;
    });
  }

  opacityFull(section) {
    section.style.opacity = "1";
  }

  opacityHalf(section) {
    section.style.opacity = "0.4";
  }

  initCollectionSelectListener() {
    const classRef = this;
    const collectionSection = this.stepsContainers[0];
    const collectionCardInputs = collectionSection.querySelectorAll(
      subscriptionSelectors.selectionCardInputs
    );

    collectionCardInputs.forEach((input) => {
      input.addEventListener("click", () => {
        classRef.handleCollectionSelection(input);
      });
    });
  }

  initFilterSelectListener() {
    const classRef = this;

    const filter1Section = this.stepsContainers[1];
    const filter1Inputs = filter1Section.querySelectorAll(
      subscriptionSelectors.selectionCardInputs
    );

    filter1Inputs.forEach((input) => {
      input.addEventListener("click", () => {
        classRef.handleFilter1Selection(input);
      });
    });

    const filter2Section = this.stepsContainers[2];
    const filter2Inputs = filter2Section.querySelectorAll(
      subscriptionSelectors.selectionCardInputs
    );

    filter2Inputs.forEach((input) => {
      input.addEventListener("click", () => {
        classRef.handleFilter2Selection(input);
      });
    });

    const filter3Section = this.stepsContainers[3];
    const filter3Inputs = filter3Section.querySelectorAll(
      subscriptionSelectors.selectionCardInputs
    );

    filter3Inputs.forEach((input) => {
      input.addEventListener("click", () => {
        classRef.handleFilter3Selection(input);
      });
    });
  }

  applyFilters() {
    const submit = document.querySelector(subscriptionSelectors.formSubmit);
    let filteredCollection = [...this.selectedCollection];

    if (!!this.filter1) {
      filteredCollection = filteredCollection.filter((product) => {
        if (product.tags.includes(this.filter1)) {
          return true;
        }
      });
    }

    if (!!this.filter2) {
      filteredCollection = filteredCollection.filter((product) => {
        if (product.tags.includes(this.filter2)) {
          return true;
        }
      });
    }

    if (!!this.filter3) {
      filteredCollection = filteredCollection.filter((product) => {
        let check = false;
        product.variants.forEach((variant) => {
          if (variant.options.includes(this.filter3)) {
            check = true;
          }
        });

        return check;
      });
    }

    this.filteredCollection = [...filteredCollection];

    this.selectedProduct = filteredCollection[0];

    if (!!this.selectedProduct) {
      this.selectedVariant = this.selectVariant(this.selectedProduct);
    }

    //if there is a selected variant enable submit button
    if (!!this.selectedVariant) {
      this.buildSummarySection();
      this.enableBtn(submit);
    } else {
      this.disableBtn(submit);
    }
  }

  disableInput(filter) {
    filter.parentElement.style.opacity = "0.4";
    filter.disabled = true;
  }

  enableInput(filter) {
    filter.parentElement.style.opacity = "1";
    filter.disabled = false;
  }

  checkIfFilterAvailable(section) {
    const filters = section.querySelectorAll(
      subscriptionSelectors.selectionCardInputs
    );
    const notAvailableMessage = section.querySelector(
      subscriptionSelectors.notAvailableMessage
    );
    let collection = [...this.filteredCollection];
    let count = 0;

    filters.forEach((filter) => {
      let check = false;
      let value = filter.value;
      collection.forEach((item) => {
        if (item.tags.includes(value)) {
          check = true;
        }
      });

      if (check) {
        count++;
        this.enableInput(filter);
      } else {
        this.disableInput(filter);
      }
    });

    if (count === 0) {
      notAvailableMessage.style.display = "block";
    } else {
      notAvailableMessage.style.display = "none";
    }
  }

  checkIfVariantAvailable(section) {
    const filters = section.querySelectorAll(
      subscriptionSelectors.selectionCardInputs
    );
    let collection = [...this.filteredCollection];

    filters.forEach((filter) => {
      let check = false;
      let value = filter.value;
      collection.forEach((item) => {
        item.variants.forEach((variant) => {
          if (variant.options.includes(value)) {
            check = true;
          }
        });
      });

      if (check) {
        this.enableInput(filter);
      } else {
        this.disableInput(filter);
      }
    });
  }

  filterUnavailableProductsFromCollection(collection) {
    const newCollection = collection.filter((product) => {
      if (product.available === true) {
        return true;
      }
    });

    this.selectedCollection = [...newCollection];
    this.filteredCollection = [...this.selectedCollection];
  }

  selectVariant(productObject) {
    const productVariant = productObject.variants.filter((variant) => {
      if (variant.options.includes(this.filter3)) {
        return true;
      }
    });

    return productVariant[0];
  }

  resetSections(sectionsArray) {
    sectionsArray.forEach((section) => {
      this.resetFilterValues(section);
      this.opacityHalf(section);
    });

    this.hideSummary();
  }

  handleCollectionSelection(cardInput) {
    this.resetForm();
    this.resetSections([
      this.stepsContainers[1],
      this.stepsContainers[2],
      this.stepsContainers[3],
    ]);
    this.filter1 = null;
    this.filter2 = null;
    this.filter3 = null;
    this.filter1Label = null;
    this.filter2Label = null;
    this.filter3Label = null;

    this.populateSelectedCollectionData(cardInput.value);
    this.filterUnavailableProductsFromCollection([
      ...this.collectionsData[cardInput.value].collectionItems,
    ]);
    this.collectionName = cardInput.value;
    this.checkIfFilterAvailable(this.stepsContainers[1]);
    this.revealNextSection(this.stepsContainers[1]);
    this.scrollToSection(this.stepsContainers[1]);
  }

  handleFilter1Selection(cardInput) {
    this.resetSections([this.stepsContainers[2], this.stepsContainers[3]]);
    this.filter2 = null;
    this.filter3 = null;
    this.filter2Label = null;
    this.filter3Label = null;
    this.filter1 = cardInput.value;
    this.filter1Label = cardInput.dataset.label;
    this.applyFilters();
    this.checkIfFilterAvailable(this.stepsContainers[2]);
    this.revealNextSection(this.stepsContainers[2]);
    this.scrollToSection(this.stepsContainers[2]);
  }

  handleFilter2Selection(cardInput) {
    this.resetSections([this.stepsContainers[3]]);
    this.filter3 = null;
    this.filter3Label = null;
    this.filter2 = cardInput.value;
    this.filter2Label = cardInput.dataset.label;
    this.applyFilters();
    this.checkIfVariantAvailable(this.stepsContainers[3]);
    this.revealNextSection(this.stepsContainers[3]);
    this.scrollToSection(this.stepsContainers[3]);
  }

  handleFilter3Selection(cardInput) {
    const summarySection = document.querySelector(
      subscriptionSelectors.summarySection
    );
    this.filter3 = cardInput.value;
    this.filter3Label = cardInput.dataset.label;
    this.applyFilters();
    this.renderSummary();
    this.scrollToSection(summarySection);
  }

  renderSummary() {
    const summarySection = document.querySelector(
      subscriptionSelectors.summarySection
    );
    summarySection.style.display = "flex";
  }

  buildSummarySection() {
    this.buildSummaryDetails();
    this.buildTotals();
  }

  hideSummary() {
    const summarySection = document.querySelector(
      subscriptionSelectors.summarySection
    );
    summarySection.style.display = "none";
  }

  initFormSubmitListener() {
    const submitBtn = document.querySelector(subscriptionSelectors.formSubmit);
    const classRef = this;
    submitBtn.addEventListener("click", (event) => {
      event.preventDefault();
      classRef.handleFormSubmit(event, submitBtn);
    });
  }

  handleFormSubmit(event, btn) {
    btn.innerHTML = "adding...";
    this.disableBtn(btn);
    this.addProductToCart(btn);
  }

  resetForm() {
    this.hideSummary();
    this.stepsContainers.forEach((step, index) => {
      if (index === 0) {
        return;
      }
      this.resetFilterValues(step);
      this.opacityHalf(step);
    });
  }

  resetFilterValues(section) {
    const inputs = section.querySelectorAll("input");
    inputs.forEach((input) => {
      input.checked = false;
      input.disabled = true;
      input.parentElement.style.opacity = "1";
    });
  }

  populateSelectedCollectionData(collectionName) {
    const selectedData = this.collectionsData[collectionName].blockData;

    const data = {
      filter1: {
        title: selectedData["filter-1-header-text"],
        option1: {
          text: selectedData["filter-1-option-1-text"],
          tag: selectedData["filter-1-option-1-tag"],
          img: selectedData["filter-1-option-1-img"],
          description: selectedData["filter-1-option-1-description"],
          descriptionBold: selectedData["filter-1-option-1-description-bold"],
        },
        option2: {
          text: selectedData["filter-1-option-2-text"],
          tag: selectedData["filter-1-option-2-tag"],
          img: selectedData["filter-1-option-2-img"],
          description: selectedData["filter-1-option-2-description"],
          descriptionBold: selectedData["filter-1-option-2-description-bold"],
        },
      },
      filter2: {
        title: selectedData["filter-2-header-text"],
        option1: {
          text: selectedData["filter-2-option-1-text"],
          tag: selectedData["filter-2-option-1-tag"],
          img: selectedData["filter-2-option-1-img"],
          description: selectedData["filter-2-option-1-description"],
          descriptionBold: selectedData["filter-2-option-1-description-bold"],
        },
        option2: {
          text: selectedData["filter-2-option-2-text"],
          tag: selectedData["filter-2-option-2-tag"],
          img: selectedData["filter-2-option-2-img"],
          description: selectedData["filter-2-option-2-description"],
          descriptionBold: selectedData["filter-2-option-2-description-bold"],
        },
      },
      filter3: {
        title: selectedData["filter-3-header-text"],
        option1: {
          text: selectedData["filter-3-option-1-text"],
          tag: selectedData["filter-3-option-1-tag"],
          img: selectedData["filter-3-option-1-img"],
          description: selectedData["filter-3-option-1-description"],
          descriptionBold: selectedData["filter-3-option-1-description-bold"],
        },
        option2: {
          text: selectedData["filter-3-option-2-text"],
          tag: selectedData["filter-3-option-2-tag"],
          img: selectedData["filter-3-option-2-img"],
          description: selectedData["filter-3-option-2-description"],
          descriptionBold: selectedData["filter-3-option-2-description-bold"],
        },
        option3: {
          text: selectedData["filter-3-option-3-text"],
          tag: selectedData["filter-3-option-3-tag"],
          img: selectedData["filter-3-option-3-img"],
          description: selectedData["filter-3-option-3-description"],
          descriptionBold: selectedData["filter-3-option-3-description-bold"],
        },
      },
    };
    let count = 1;
    for (const filter in data) {
      this.populateSelectionData(count, data[filter]);
      count++;
    }
  }

  populateSelectionData(index, selectionData) {
    const cardSelector = "label";
    const headerSelector = "legend";
    const sectionEl = this.stepsContainers[index];
    const headerEl = sectionEl.querySelector(headerSelector);
    const options = !!selectionData.option3
      ? [selectionData.option1, selectionData.option2, selectionData.option3]
      : [selectionData.option1, selectionData.option2];

    headerEl.innerHTML = selectionData.title;

    const cards = sectionEl.querySelectorAll(cardSelector);
    cards.forEach((card, index) => {
      buildCard(card, options[index]);
    });

    function buildCard(cardEl, data) {
      const title = cardEl.querySelector(subscriptionSelectors.cardTitle);
      const img = cardEl.querySelector(subscriptionSelectors.cardImg);
      const input = cardEl.querySelector(subscriptionSelectors.cardInput);
      const description = cardEl.querySelector(
        subscriptionSelectors.cardDescription
      );

      input.dataset.label = data.text;
      title.innerHTML = data.text;

      if (!!data.img) {
        img.src = data.img;
        img.alt = data.text;
      }

      img.alt = data.text;
      input.value = data.tag;
      if (!!description) {
        description.innerText = data.description;
      }

      if (!!data.descriptionBold && !!description) {
        const boldTextEl = document.createElement("span");
        boldTextEl.innerHTML = data.descriptionBold;
        description.appendChild(boldTextEl);
      }
    }
  }

  buildTotals() {
    const savingEls = document.querySelectorAll(
      subscriptionSelectors.subSavings
    );
    const totalEls = document.querySelectorAll(subscriptionSelectors.subTotal);
    let discount = this.selectedVariant.price / 100 / 10 * 2
    const discountPrice = this.formatMoney(
      this.selectedVariant.price / 100 - discount
    );
    const difference = this.formatMoney(
		discount
    );

    savingEls.forEach((el) => {
      el.innerHTML = `${difference}`;
    });

    totalEls.forEach((el) => {
      el.innerHTML = `${discountPrice}`;
    });
  }

  formatMoney(money) {
    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    return formatter.format(money);
  }

  buildSummaryDetails() {
    const summarySection = document.querySelector(
      subscriptionSelectors.summarySection
    );
    const SummaryLine1 = summarySection.querySelectorAll(
      subscriptionSelectors.subDetail1
    );
    const SummaryLine2 = summarySection.querySelectorAll(
      subscriptionSelectors.subDetail2
    );
    const SummaryLine3 = summarySection.querySelectorAll(
      subscriptionSelectors.subDetail3
    );
    const SummaryLine4 = summarySection.querySelectorAll(
      subscriptionSelectors.subDetail4
    );
    const summaryImage = summarySection.querySelector(
      subscriptionSelectors.subDetailImg
    );

    if (SummaryLine1.length > 0) {
      setInnerHTML(SummaryLine1, this.collectionName);
    }

    if (SummaryLine2.length > 0) {
      setInnerHTML(SummaryLine2, this.filter1Label);
    }

    if (SummaryLine3.length > 0) {
      setInnerHTML(SummaryLine3, this.filter2Label);
    }

    if (SummaryLine4.length > 0) {
      setInnerHTML(SummaryLine4, this.filter3Label);
    }

    function setInnerHTML(nodeList, innerText) {
      nodeList.forEach((el) => {
        el.innerHTML = `${innerText}`;
      });
    }

    if (!!summaryImage) {
      summaryImage.src = this.selectedProduct.featured_image;
      summaryImage.alt = this.selectedProduct.title;
    }
  }

  scrollToSection(section) {
    section.scrollIntoView({ block: "center", behavior: "smooth" });
  }

  hideSummary() {
    const summarySection = document.querySelector(
      subscriptionSelectors.summarySection
    );
    summarySection.style.display = "none";
  }

  enableBtn(btn) {
    btn.disabled = false;
    btn.style.opacity = "1";
  }

  disableBtn(btn) {
    btn.disabled = true;
    btn.style.opacity = "0.4";
  }

  addProductToCart(btn) {
    const url = "/cart/add.js";

    const data = {
      id: this.selectedVariant.id,
      quantity: 1,
      selling_plan:
        this.selectedVariant.selling_plan_allocations[3]?.selling_plan_id ||
        this.selectedVariant.selling_plan_allocations[0]?.selling_plan_id,
    };

    const options = {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      referrerPolicy: "no-referrer",
      body: JSON.stringify(data),
    };

    const request = fetch(url, options).then((data) => {
      this.enableBtn(btn);
      btn.innerHTML = "submit";

      const cartCounts = document.querySelectorAll(".cart_count");
      cartCounts.forEach((count) => {
        const curr = Number(count.innerText);
        count.innerText = curr + 1;
      });
    });
  }
}
